import React from "react";
import { Select } from "antd";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import './phonenumber.scss';

const { Option } = Select;

const PhoneNumberInput = ({ value, disabled = false, callback, countryCode, updateInput, inputName, countryCodeName,required=false, otherProps={}, type}) => {
  const getKeyByValue = (targetValue) => {
    return Object.keys(en).find((key) => en[key] === targetValue) || null;
  };

  const onPhoneNumberChange = (value) => {
    const code = getCountryCallingCode(getKeyByValue(value));
    if(type === 'tel') {
      callback(code);
    } else {
      callback((prev) => ({ ...prev, countryCode: code }));
    }
    
  };

  return (
    <div style={{ display: "flex" }}>
      <Select
        placeholder=""
        allowClear
        onSelect={onPhoneNumberChange}
        showSearch
        style={{ width: "45%" }}
        value={countryCode}
        disabled={disabled}
        name={countryCodeName}
        required={required}
        className={'input-field country-code'}
      >
        {getCountries().map((country) => (
          <Option key={country} value={en[country]}>
            {en[country]} +{getCountryCallingCode(country)}
          </Option>
        ))}
      </Select>

      <input
        type="tel"
        name={inputName}
        value={value}
        onChange={updateInput}
        className={`input-field phone-input`}
        disabled={disabled}
        required={required}
        {...otherProps}
      />
    </div>
  );
};

export default PhoneNumberInput;
